import { Link } from "react-router-dom";
import useReveal from "../hooks/useReveal";
import "./Services.css";
import { config } from "../config";

const SERVICES = [
  {
    id: "web",
    icon: "💻",
    eye: "Website Development",
    path: "/services/website-development",
    title: "Websites That Work As Hard As You Do",
    desc: "We engineer blazing-fast, pixel-perfect websites that convert visitors into customers. From elegant landing pages to complex enterprise platforms - built with modern frameworks and obsessive attention to detail.",
    color: "var(--gold)",
    features: [
      "Custom UI/UX Design",
      "React / Next.js / WordPress",
      "SEO-Optimised Architecture",
      "Mobile-First Responsive",
      "E-Commerce & Payment Integration",
      "Performance & Core Web Vitals",
      "CMS Integration",
      "3 Months Free Support",
    ],
  },
  {
    id: "marketing",
    icon: "📈",
    eye: "Digital Marketing",
    title: "Growth-Driven Marketing That Delivers ROI",
    path: "/services/digital-marketing",
    desc: "Data-driven campaigns that connect your brand with exactly the right audience at exactly the right moment. We craft full-funnel strategies across SEO, paid media, social, and email that deliver measurable, compounding results.",
    color: "var(--accent2)",
    features: [
      "SEO & Content Strategy",
      "Google & Meta Ads",
      "Social Media Management",
      "Email Marketing Campaigns",
      "Analytics & Monthly Reporting",
      "Conversion Rate Optimisation",
      "Influencer Marketing",
      "Quarterly Strategy Reviews",
    ],
  },
  {
    id: "design",
    icon: "🎨",
    eye: "Graphics Design",
    path: "/services/graphics-design",
    title: "Visual Identities That Command Attention",
    desc: "From brand identity to UI/UX design, our creative team crafts visuals that tell your story with real impact. We blend aesthetics with strategy to produce designs that look stunning and perform even better.",
    color: "var(--accent)",
    features: [
      "Brand Identity & Logo Design",
      "UI/UX Design (Figma)",
      "Social Media Graphics",
      "Marketing Collateral",
      "Packaging Design",
      "Motion Graphics & Animation",
      "Illustration",
      "Print & Digital Assets",
    ],
  },
];

const TOOLS = [
  "Figma",
  "React",
  "Next.js",
  "WordPress",
  "Shopify",
  "Google Ads",
  "Meta Ads",
  "Mailchimp",
  "Framer",
  "After Effects",
  "Illustrator",
  "Webflow",
];

export default function Services() {
  useReveal();
  const marquee = [...TOOLS, ...TOOLS];

  return (
    <div className="services-page">
      {/* PAGE HERO */}
      <div className="page-hero">
        <span className="ph-eye">What We Offer</span>
        <h1 className="ph-title">
          Services Designed for <span className="g">Digital Success</span>
        </h1>
        <p className="ph-sub">
          Three core pillars of digital excellence - each executed with
          precision, passion, and an obsession for results.
        </p>
      </div>

      {/* TOOLS MARQUEE */}
      <div className="marquee-section">
        <div className="marquee-track">
          {marquee.map((t, i) => (
            <div className="marquee-item" key={i}>
              <span className="dot" />
              {t}
            </div>
          ))}
        </div>
      </div>

      {/* SERVICE BLOCKS */}
      {SERVICES.map((s, i) => {
        const isEven = i % 2 === 0;
        return (
          <section
            key={s.id}
            id={s.id}
            className={`svc-block ${isEven ? "" : "svc-block--alt"}`}
          >
            <div className="container">
              <div
                className={`svc-block__grid ${isEven ? "" : "svc-block__grid--rev"}`}
              >
                {/* Content */}
                <div className={isEven ? "rl" : "rr"}>
                  <div className="svc-block__icon" style={{ "--sc": s.color }}>
                    {s.icon}
                  </div>
                  <span className="s-eye" style={{ color: s.color }}>
                    {s.eye}
                  </span>
                  <h2 className="s-title">{s.title}</h2>
                  <p className="s-body">{s.desc}</p>
                  <Link
                    to={`${config.appUrl}contact`}
                    className="btn-primary"
                    style={{ marginTop: "2.5rem", display: "inline-flex" }}
                  >
                    Get a Quote →
                  </Link>
                </div>

                {/* Features card */}
                <div className={isEven ? "rr" : "rl"}>
                  <div className="features-card" style={{ "--sc": s.color }}>
                    <div className="features-card__glow" />
                    <p className="features-card__label">What's Included</p>
                    <ul className="features-list">
                      {s.features.map((f) => (
                        <li key={f} className="features-list__item">
                          <span
                            className="feat-check"
                            style={{ color: s.color }}
                          >
                            ✦
                          </span>
                          <span>{f}</span>
                        </li>
                      ))}
                    </ul>
                    <Link
                      to={`${config.appUrl}${s.path}`}
                      key={s.title}
                      className="btn-ghost"
                      style={{ marginTop: "2rem" }}
                    >
{/*                       
                    </Link>
                    <Link
                      to={`${config.appUrl}web-development-package`}
                      className="btn-ghost"
                      style={{ marginTop: "2rem" }}
                    > */}
                      View Pricing →
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        );
      })}

      {/* BOTTOM CTA */}
      <div className="cta-sect">
        <div className="cta-glow" />
        <div
          className="container"
          style={{ position: "relative", textAlign: "center" }}
        >
          <div className="reveal">
            <span
              className="s-eye"
              style={{ display: "block", textAlign: "center" }}
            >
              Not Sure Where to Start?
            </span>
            <h2 className="cta-title">
              Book a Free <span className="g">Consultation</span>
            </h2>
            <p className="cta-body">
              30 minutes. No fluff, no pressure. Just a clear strategy tailored
              to your business goals.
            </p>
            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Link to={`${config.appUrl}contact`} className="btn-primary">
                Book Free Call →
              </Link>
              <Link
                to={`${config.appUrl}web-development-package`}
                className="btn-outline"
              >
                See Packages
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
